import type { ContextMenuActionItem as ContextMenuActionItemType } from "../types/contextMenu.types";
import { isMenuItemDisabled } from "../helpers/contextMenu.helpers";

type ContextMenuActionItemProps<TContext> = {
    item: ContextMenuActionItemType<TContext>;
    context: TContext;
    closeMenu: () => void;
};

export function ContextMenuActionItem<TContext>({
    item,
    context,
    closeMenu,
}: ContextMenuActionItemProps<TContext>) {
    const disabled = isMenuItemDisabled(item, context);

    const handleSelect = async () => {
        if (disabled) {
            return;
        }

        await item.onSelect(context);
        closeMenu();
    };

    return (
        <button
            type="button"
            role="menuitem"
            disabled={disabled}
            onClick={handleSelect}
            style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 8,
                border: 0,
                background: "transparent",
                padding: "8px 10px",
                borderRadius: 6,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.5 : 1,
                color: item.danger ? "#c62828" : "inherit",
                textAlign: "left",
            }}
        >
            {item.icon ? <span aria-hidden>{item.icon}</span> : null}

            <span style={{ flex: 1 }}>{item.label}</span>

            {item.shortcut ? (
                <kbd
                    style={{
                        fontSize: 11,
                        opacity: 0.6,
                    }}
                >
                    {item.shortcut}
                </kbd>
            ) : null}
        </button>
    );
}